var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjectifBaisse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_933_2696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2088 14.3338C40.218 14.3338 39.4171 15.1347 39.4171 16.1254V26.1337L27.6584 14.3768C25.2504 11.9688 21.332 11.9688 18.924 14.3768L14.3069 18.9939C13.334 19.9668 11.7484 19.9668 10.7755 18.9939L3.05882 11.2754C2.35828 10.5749 1.22595 10.5749 0.525406 11.2754C-0.175135 11.9759 -0.175135 13.1083 0.525406 13.8088L8.24391 21.5273C10.6125 23.8959 14.4735 23.8959 16.8421 21.5273L21.4592 16.9102C22.4697 15.8997 24.1145 15.8997 25.1268 16.9102L36.8837 28.6671H26.8754C25.8847 28.6671 25.0838 29.468 25.0838 30.4588C25.0838 31.4496 25.8847 32.2504 26.8754 32.2504H37.6255C40.5889 32.2504 43.0005 29.8389 43.0005 26.8754V16.1254C43.0005 15.1347 42.1996 14.3338 41.2088 14.3338Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_933_2696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectifBaisse);
export default __webpack_public_path__ + "static/media/objectif_baisse.d8836ca15a317b2038099531833614da.svg";
export { ForwardRef as ReactComponent };